// src/components/job-center.config.ts
import { CheckCircle2, XCircle, AlertTriangle, Zap, Hourglass, Loader, Pause, RotateCcw, Package, Workflow } from 'lucide-react';
import type { JobRecord } from '../hooks/useJobCenter';

export type JobStatus = JobRecord['status'] | 'chunked' | 'merging';

export const STATUS_CONFIG: Record<JobStatus, {
    label: string;
    Icon: React.ElementType;
    color: string;
    priority: number;
}> = {
    pending: {
        label: "En attente",
        Icon: Hourglass,
        color: 'bg-amber-500/90 text-amber-900',
        priority: 1,
    },
    processing: {
        label: "En cours",
        Icon: Loader,
        color: 'bg-blue-600/90',
        priority: 2,
    },
    chunked: {
        label: "En traitement (lot)",
        Icon: Package,
        color: 'bg-purple-600/90',
        priority: 2.5,
    },
    merging: {
        label: "Fusion",
        Icon: Workflow,
        color: 'bg-indigo-600/90',
        priority: 2.8,
    },
    completed: {
        label: "Terminé",
        Icon: CheckCircle2,
        color: 'bg-green-600/90',
        priority: 3,
    },
    failed: {
        label: "Échec",
        Icon: XCircle,
        color: 'bg-red-600/90',
        priority: 4,
    },
    cancelled: {
        label: "Annulé",
        Icon: AlertTriangle,
        color: 'bg-white/10 text-white/60',
        priority: 5,
    },
    paused: {
        label: "En pause",
        Icon: Pause,
        color: 'bg-orange-500/90 text-orange-900',
        priority: 6,
    },
    retrying: {
        label: "Nouvelle tentative",
        Icon: RotateCcw,
        color: 'bg-purple-500/90 text-purple-900',
        priority: 7,
    },
};

export function formatDuration(ms: number): string {
    if (ms < 0) ms = 0;
    if (ms < 1000) return `${ms}ms`;
    const s = ms / 1000;
    if (s < 60) return `${s.toFixed(1)}s`;
    const m = Math.floor(s / 60);
    const remainingSeconds = Math.round(s % 60);
    return `${m}m ${remainingSeconds}s`;
}